<template>
  <div class="w-100 pr-3">
    <b-dropdown
      class="m-2 w-100 text-center bg-black rounded"
      toggle-class="text-decoration-none"
      no-caret
      variant="transparent"
      dropup
    >
      <template #button-content>
        <span class="font-weight-bold text-white">
          {{ projectName }}
        </span>

        <b-button variant="transparent">
          <img src="@/assets/icons/chevron-down.svg" width="15" height="15" />
        </b-button>
      </template>

      <b-dropdown-item
        v-for="(project, projectId) in projects"
        :key="projectId"
        :to="{ name: 'ProjectTaskWizard', params: { projectId } }"
      >
        {{ project.name }}
      </b-dropdown-item>

      <b-dropdown-divider />

      <b-dropdown-item :to="{ name: 'ProjectWizard' }">
        Create Space
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { BButton, BDropdown, BDropdownItem, BDropdownDivider } from "bootstrap-vue";

export default {
  name: "ProjectList",
  components: {
    BButton,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
  },
  computed: {
    ...mapState({ projects: (state) => state.projects.items }),
    projectId() {
      return this.$route.params.projectId;
    },
    projectName() {
      const { projectId } = this;
      return this.projects[projectId]?.name;
    },
  },
  data: () => ({}),
};
</script>
